import { alpha, Chip, Stack, Typography, useTheme } from '@mui/material';

import { getAlgorithmChipColor } from '../../common';
import { AlgorithmsStatus } from '../../types';

interface AlgorithmCellProps {
  algorithmsStatus: AlgorithmsStatus[];
}

const AlgorithmCell = ({ algorithmsStatus }: AlgorithmCellProps) => {
  const themeMode = useTheme().palette.mode;

  if (!algorithmsStatus.length) {
    return (
      <Typography
        variant='subtitleNumbers'
        component='span'
        color='textSecondary'
      >
        None
      </Typography>
    );
  }

  return (
    <Stack gap={2} alignItems='flex-start'>
      {algorithmsStatus.map(({ id, name, color, version }) => {
        const colors = getAlgorithmChipColor(color, themeMode);

        return (
          <Chip
            key={id}
            label={`${name} ${version ? `(${version})` : ''}`}
            size='small'
            sx={{
              fontFamily: (theme) => theme.typography.subtitleLabel.fontFamily,
              fontSize: '0.75rem',
              lineHeight: '1.125rem',
              color: colors.text,
              backgroundColor: alpha(colors.bgColor, 0.5),
            }}
          />
        );
      })}
    </Stack>
  );
};

export default AlgorithmCell;
